module.exports = __webpack_public_path__ + "img/ch16.4271ec09.jpg";